module.exports = __webpack_public_path__ + "static/img/my-09-3-x.873b948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tip/my-09-3-x.png
// module id = 91Ai
// module chunks = 1